import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

export default function NewsletterConfirmPage() {
  const { token } = useParams();
  const [state, setState] = useState({ status: "loading", email: null, message: null });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/newsletter/confirm?token=${encodeURIComponent(token)}`
        );
        const data = await res.json().catch(() => ({}));
        if (cancelled) return;
        if (res.ok) {
          setState({
            status: data.status || "confirmed",
            email: data.email,
            message:
              data.status === "already_confirmed"
                ? "Cette adresse est déjà inscrite à la newsletter."
                : "Merci ! Votre inscription à la newsletter ITERCATUS est confirmée.",
          });
        } else if (res.status === 410) {
          setState({ status: "expired", email: null, message: "Ce lien a expiré. Merci de recommencer depuis la page d'accueil." });
        } else {
          setState({ status: "invalid", email: null, message: "Ce lien de confirmation est invalide." });
        }
      } catch (e) {
        if (!cancelled)
          setState({ status: "error", email: null, message: "Une erreur réseau est survenue. Merci de réessayer plus tard." });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4 py-16" data-testid="newsletter-confirm-page">
      <div className="max-w-lg w-full bg-white rounded-xl shadow-md p-8 text-center">
        <h1 className="font-heading text-2xl text-primary mb-4">Inscription newsletter</h1>
        {state.status === "loading" ? (
          <p className="text-slate-500 animate-pulse">Confirmation en cours…</p>
        ) : (
          <>
            <p className="text-slate-700 leading-relaxed" data-testid="newsletter-confirm-message">
              {state.message}
            </p>
            {state.email && (
              <p className="text-xs text-slate-400 mt-3">{state.email}</p>
            )}
            <div className="mt-8">
              <Link to="/" className="btn-primary inline-block px-6 py-2 rounded-full text-white bg-accent hover:bg-accent/90 font-semibold">
                Retour à l'accueil
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
